import { FolderStructureDTO } from "../DTO/folderStructureDTO";

export class StoreFolderStructureRequest {
    public userId!:string;
    public businessId!:string;
    public folderStructure!:FolderStructureDTO;
    
    constructor(){
    }
}